/**
 * 重连退避（story AC-3，复刻源 App ImEngineBackoff）：
 *   base = min(1000 · 2^attempt, 30000)，attempt 钳 [0,30]
 *   delay = round(base · jitter)，jitter ∈ [0.8, 1.2)
 */
export const MAX_BACKOFF_MS = 30_000;

export function computeBackoffDelay(attempt: number, rand: () => number = Math.random): number {
  const clamped = Math.max(0, Math.min(Math.floor(attempt), 30));
  const base = Math.min(1000 * 2 ** clamped, MAX_BACKOFF_MS);
  const jitter = 0.8 + rand() * 0.4;
  return Math.round(base * jitter);
}
